import React, { useState } from "react";
import biswa from "../assets/img/biswa.png"
import logo_pms from "../assets/img/logo_pms.png";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  // Simple Styles
  const styles = {
    navbar: {
      backgroundColor: "#026D7C",
      padding: "5px",
      display: "flex",
      justifyContent: "left",
    },
    dropdown: {
      position: "relative",
      display: "inline-block",
    },
    dropdownButton: {
      backgroundColor: "#026D7C",
      color: "white",
      padding: "4px 15px",
      fontSize: "15px",
      border: "none",
      cursor: "pointer",
    },
    dropdownContent: {
      position: "absolute",
      top: "100%",
      left: "0",
      backgroundColor: "white",
      minWidth: "180px",
      boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
      zIndex: 1,
      borderRadius: "4px",
    },
    dropdownItem: {
      padding: "10px",
      textDecoration: "none",
      display: "block",
      color: "#026D7C",
      fontSize: "16px",
    },
    dropdownItemHover: {
      backgroundColor: "black",
    },
  };
  return (
    <div class="wrapper">

      <div class="grid-x grid-padding-x">
        <div class="large-1 medium-1 small-12 cell">
          <div class="grid-x grid-margin-x align-left">
            <div class="large-12 medium-12 small-12 cell">
              <img src={biswa} style={{ "padding": "20px" }} />
            </div>
          </div>
        </div>
        <div class="large-10 medium-10 small-12 cell">
          <div class="grid-x grid-margin-x align-center">
            <div class="large-4 medium-4 small-12 cell">
              <a >
                <img src={logo_pms} /></a>
            </div>
          </div>
        </div>
      </div>
      <nav style={styles.navbar}>
        <div style={styles.dropdown}>
          <button><Link to="/add-certificate" style={styles.dropdownButton}>
            Apply Certificate
          </Link>
          </button>
          <button onClick={toggleDropdown} style={styles.dropdownButton}>
            <Link to="/certificate-list" style={styles.dropdownButton} >
              Application Status and Certificate Download
            </Link>
          </button>

        </div>
      </nav>
    </div>
  )
}
export default Navbar;

